import { motion } from "framer-motion";
import Header from "../components/Header";
import Footer from "../components/Footer";
// import "./About.css"; // Make sure this CSS includes the improved styles

const teamMembers = [
  {
    name: "CA Sunil Dad, FCA, Bcom",
    img: "/assets/img/CAsunil.JPG",
    experience: "22 years",
    description: `A seasoned chartered accountant with 22 years of experience in assignments relating to income tax, audits, RBI compliances, and other financial services. Expert in project financing, business planning, valuations.`,
    expertise: [
      "Income Tax: Expert in laws, regulations, and assessment proceedings",
      "Audits: Internal and external audits across industries",
      "RBI Compliances: Regulatory requirements for financial institutions",
      "Financial Services: Planning, budgeting, and financial analysis",
    ],
  },
  {
    name: "CA Praveen Toshniwal, FCA, Bcom, DISA, FAFD",
    img: "/assets/img/CApraveen.JPG",
    experience: "19 years",
    description: `He has professional experience over 19 years, bearing expertise in Corporate planning, Auditing compliance management, stock exchange compliance and business restructuring.`,
    expertise: [
      "Corporate Planning: Developing strategic plans for businesses to achieve their goals",
      "Auditing: Conducting internal and external audits",
      "Compliance Management: Ensuring adherence to laws and regulations",
      "Stock Exchange Compliance: Guidance on SEBI regulations",
      "Restructuring through IPOs: Assisting companies in IPOs, right issues etc",
    ],
  },
  {
    name: "CA Malay Pandit, FCA, Bcom",
    img: "/assets/img/CAmalay.jpeg",
    experience: "32 years",
    description: `Professional experience over 32 years in auditing, company law matters, merger and amalgamations, secretarial compliances and taxation matters.`,
    expertise: [
      "Auditing: Internal and external audits",
      "Company Law Matters: Incorporation, compliance, and governance",
      "Merger and Amalgamations: Handling mergers and corporate restructuring",
      "Secretarial Compliances: Board meetings, AGM, corporate governance",
      "Taxation: Compliance of Indirect Taxation",
    ],
  },
  {
    name: "CA Shobha Rohit Bisht, FCA, Bcom",
    img: "/assets/img/CAshobha.jpeg",
    experience: "8 years",
    description: `Professional experience over 8 years in statutory bank audit, concurrent audits, risk-based audits and due diligence. Managing Mumbai Branch.`,
    expertise: [
      "Auditing – Concurrent, Statutory & Revenue audits of Banks",
      "Income Tax: Expertise in laws, regulations, and compliance",
      "Corporate Planning: Developing strategic business plans",
    ],
  },
  {
    name: "CA Ankita Rathi, ACA, Bcom",
    img: "/assets/img/ANKITA PIC.png",
    experience: "7 years",
    description: `Professional experience over 7 years in tax audit, bank audit, ROC Compliance and Company Law Consultancy. Handling Bhilwara Branch.`,
    expertise: [
      "Auditing – Concurrent, Statutory & Revenue audits of Banks",
      "Income Tax: Expertise in laws, regulations, and compliance",
    ],
  },
];


const items = [
  {
    number: 1,
    title: "Year 2004",
    text: "Established as a proprietorship firm under the name Sunil Dad & Co.",
  },
  {
    number: 2,
    title: "Year 2006",
    text: "Converted into a partnership firm with Mr. Praveen Toshniwal and Mr. Sunil Dad as partners.",
  },
  {
    number: 3,
    title: "Year 2017",
    text: "Mr. Malay Pandit, Chartered Accountant, joined the firm.",
  },
  {
    number: 4,
    title: "Year 2021",
    text: "Expanded operations with new branches in Mumbai and Bhilwara.",
  },
];

const About = () => {

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section
        className="about-hero"
        style={{ backgroundImage: "url('/assets/img/img2.jpeg')" }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>About Our Firm</h1>
          <p>Committed to excellence in accounting, audit & taxation.</p>
        </div>
      </section>

      {/* About Intro */}
      <section className="about-intro py-5">
        <div className="container text-center">
          <h2 className="section-title mb-4">Who We Are</h2>
        
          <p className="service-text mt-3">
            Content CHange - S D P M & Co is a firm of Chartered Accountants
            providing audit, taxation, and advisory services with a strong focus
            on accuracy, regulatory compliance, and professional integrity. We
            work closely with businesses and promoters to deliver practical,
            technically sound solutions aligned with statutory requirements and
            commercial objectives.
          </p>
        </div>
      </section>

      {/* <section className="creativeAbout-wrapper">
       
        <div className="shape shape1"></div>
        <div className="shape shape2"></div>

        <div className="container creative-grid">
        
          <motion.div
            className="creative-left"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
          >
            <p className="tag">ABOUT US</p>

            <h1 className="title">
              A CA firm that thinks in{" "}
              <span className="title-bold">numbers</span>
         
              but speaks in <span className="title-green">clarity.</span>
            </h1>

            <p className="subtitle">
              We started with a simple promise: make tax, GST, audit and
              compliances less intimidating for business owners, and more
              aligned with where they want to go.
            </p>

            <div className="feature-list mt-3">
              <motion.div
                className="feature-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
              >
                <h4>Built for growing businesses</h4>
                <p>
                  From first-year startups to established companies, our systems
                  are designed to scale with you.
                </p>
              </motion.div>

              <motion.div
                className="feature-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 }}
              >
                <h4>Beyond just filings</h4>
                <p>
                  We don’t just “submit forms”. We explain, plan and help you
                  see the story behind your numbers.
                </p>
              </motion.div>

              <motion.div
                className="feature-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4 }}
              >
                <h4>Multi-disciplinary expertise</h4>
                <p>
                  Tax, audit, GST, ROC, funding and advisory under one
                  coordinated team.
                </p>
              </motion.div>

              <motion.div
                className="feature-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.5 }}
              >
                <h4>Tech-enabled, human-led</h4>
                <p>
                  Structured processes, internal trackers and tools – with a
                  single relationship manager for you.
                </p>
              </motion.div>
            </div>
          </motion.div>

         
        </div>
      </section> */}

      {/* <section className="wpf-section">
        <div className="wpf-inner">
          <header className="wpf-header">
            <div className="wpf-eyebrow">HOW WE WORK</div>
            <h2 className="wpf-title">Our approach to every assignment</h2>
            <p className="wpf-lead">
              Whether it’s a simple return or a complex compliance requirement,
              our approach remains transparent, structured, and collaborative.
            </p>
          </header>

          <div className="wpf-grid">
            
            <div className="wpf-steps card-elev">
              {STEPS.map((s, i) => (
                <article
                  key={i}
                  className="wpf-step"
                  style={{ animationDelay: `${i * 0.12}s` }}
                >
              

                  <div className="wpf-body">
                    <h3 className="wpf-step-title">{s.title}</h3>
                    <p className="wpf-step-text">{s.text}</p>
                  </div>
                </article>
              ))}
            </div>

          
            <aside className="wpf-side glass">
              <span className="wpf-pill">For you</span>
              <h3 className="wpf-side-title">
                What this means for your business
              </h3>
              <p className="wpf-side-desc">
                No missed deadlines, no last-minute rush, no confusion.
                Everything stays organised and transparent.
              </p>

              <ul className="wpf-side-list">
                <li>On-time filing every month</li>
                <li>Clear documentation for audits</li>
                <li>Easy access to all proofs</li>
                <li>Dedicated senior expert review</li>
              </ul>
            </aside>
          </div>
        </div>
      </section> */}

   

      {/* <section className="oss-root" aria-labelledby="oss-heading">
        <div className="oss-inner">
    
          <div className="oss-top">
            <span className="oss-label" aria-hidden>
              {smallLabel}
            </span>

            <h2 id="oss-heading" className="oss-heading">
              {heading}
            </h2>

            <p className="oss-lead">{lead}</p>

            <a
              className="oss-cta"
              href="#contact"
              aria-label="Talk to a partner"
            >
              {ctaText}
            </a>
          </div>

         
          <div className="container">
            <div className="oss-cards">
              
              <article
                className="oss-card oss-card--feature"
               
                aria-labelledby="intro-title"
              >
                <h3 id="intro-title" className="oss-card-title">
                  {leftCard.title}
                </h3>

                <div className="oss-card-body">
                  {leftCard.paragraphs.map((p, i) => (
                    <p key={i} className="oss-card-para">
                      {p}
                    </p>
                  ))}
                </div>
              </article>

              
              <aside
                className="oss-card oss-card--values"
               
                aria-labelledby="values-title"
              >
                <div id="values-title" className="oss-pill">
                  {rightCard.pill}
                </div>

                <div className="oss-values-list">
                  {rightCard.items.map((it, idx) => (
                    <div className="oss-value" key={idx}>
                      <div className="oss-value-dot" aria-hidden></div>
                      <div className="oss-value-content">
                        <div className="oss-value-title">{it.title}</div>
                        <div className="oss-value-text">{it.text}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section> */}

      <section className="about-team-area py-5">
        <div className="container">
          <h2 className="about-section-title text-center mb-5">
            Our Expert Team
          </h2>

          {teamMembers.map((member, index) => (
            // <motion.div
            //   key={index}
            //   className={`about-team-card row align-items-center mb-5 ${
            //     index % 2 !== 0 ? "about-team-card-reverse" : ""
            //   }`}
            //   initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
            //   whileInView={{ opacity: 1, x: 0 }}
            //   transition={{ duration: 0.8, delay: index * 0.2 }}
            //   viewport={{ once: true }}
            // >
            //   {/* Image Column */}
            //   <div className="about-team-card-image col-md-5">
            //     <img
            //       src={member.img}
            //       alt={member.name}
            //       className="about-team-img"
            //     />
            //     <div className="about-team-card-deco"></div>
            //   </div>

            //   {/* Text Column */}
            //   <div className="about-team-card-info col-md-7">
            //     <h3 className="about-team-name">{member.name}</h3>
            //     <p className="about-team-bio">{member.description}</p>
            //     <ul className="about-team-skills">
            //       {member.expertise.map((item, idx) => (
            //         <li key={idx}>{item}</li>
            //       ))}
            //     </ul>
            //     <p className="about-team-experience">
            //       <strong>Experience:</strong> {member.experience}
            //     </p>
            //   </div>
            // </motion.div>

            <motion.div
              key={index}
              className={`about-team-card row align-items-center mb-5 ${
                index % 2 !== 0 ? "about-team-card-reverse" : ""
              }`}
              initial={{ opacity: 0, x: -60 }} // ALWAYS animate from left
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              {/* Image Column */}
              <div className="about-team-card-image col-md-5">
                <img
                  src={member.img}
                  alt={member.name}
                  className="about-team-img"
                />
                <div className="about-team-card-deco"></div>
              </div>

              {/* Text Column */}
              <div className="about-team-card-info col-md-7">
                <h3 className="about-team-name">{member.name}</h3>
                <p className="about-team-bio">{member.description}</p>
                <ul className="about-team-skills">
                  {member.expertise.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
                <p className="about-team-experience">
                  <strong>Experience:</strong> {member.experience}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Milestones Timeline */}
      <section
        className="milestones-section"
        aria-labelledby="milestones-heading"
      >
        <div className="container">
          <div className="intro">
            <div className="tag">MILESTONES</div>
            <h2 id="milestones-heading" className="oss-heading">
              Key moments in our journey
            </h2>
            <p className="subtitle">
              A brief snapshot of how the firm has evolved — and how that
              experience benefits you today.
            </p>
          </div>

          <div
            className="cards-wrap"
            role="list"
            aria-label="Timeline milestones"
          >
            {/* Elevated card that contains the 4 columns */}
            <div className="timeline-card" role="listitem">
              <div className="timeline-line" aria-hidden="true" />
              <div className="milestones-grid">
                {items.map((it, idx) => (
                  <article key={idx} className="milestone-item" tabIndex={0}>
                    <div className="milestone-top">
                      <div className="milestone-badge" aria-hidden="true">
                        <span className="badge-number">{it.number}</span>
                      </div>
                      <div className="divider" />
                    </div>

                    <h3 className="milestone-title">{it.title}</h3>
                    <p className="milestone-text">{it.text}</p>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default About;
